import { API } from './redux/API';

export default API;
